import { service_model_dto } from "organized";
import { BaseService } from "./_common/_baseService";
import { portalHttpService } from "./_common/httpService";
class LabelsService extends BaseService {
  constructor() {
    super("labels");
  }

  public getLabels = async (locale: string): Promise<any> => {
    return await portalHttpService.get(`${this.baseApiUrl()}/getLabels?locale=${locale}`);
  };

  public getServiceModels = async (): Promise<service_model_dto[]> => {
    const data = await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetServiceModels`);
    return data.map((item) => new service_model_dto(item));
  };
}

export const labelsService = new LabelsService();
